import { render } from "./setpassword.vue?vue&type=template&id=97978682&scoped=true"
import script from "./setpassword.vue?vue&type=script&lang=js"
export * from "./setpassword.vue?vue&type=script&lang=js"

import "./setpassword.vue?vue&type=style&index=0&id=97978682&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.www/src/fe-www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97978682"]])

export default __exports__